import { Avatar, AvatarGroup, Chip, Skeleton, Stack, Typography } from '@mui/material'

export const MetadataSkeleton = () => (
  <Stack direction="row" justifyContent="space-between">
    <Stack>
      <Stack>
        <Skeleton>
          <Typography variant="h5">foobar foobar</Typography>
        </Skeleton>
        <Skeleton>
          <Typography variant="body2">foobar</Typography>
        </Skeleton>
      </Stack>
      <Stack direction="row" spacing={0.5}>
        <Skeleton>
          <Typography variant="caption">foobar</Typography>
        </Skeleton>
      </Stack>
      <Skeleton>
        <Stack direction="row" spacing={0.5}>
          <Chip size="small" label="foobar" />
          <Chip size="small" label="foobar" />
          <Chip size="small" label="foobar" />
        </Stack>
      </Skeleton>
    </Stack>
    <Stack alignItems="flex-end">
      <Skeleton>
        <AvatarGroup max={4}>
          <Avatar alt="John Smith" />
          <Avatar alt="John Smith" />
          <Avatar alt="John Smith" />
          <Avatar alt="John Smith" />
        </AvatarGroup>
      </Skeleton>
      <Skeleton>
        <Typography variant="caption">foobar foobar</Typography>
      </Skeleton>
      <Skeleton>
        <Typography variant="caption">foobar foobar</Typography>
      </Skeleton>
      <Skeleton>
        <Typography variant="body2">foobar foobar foobar</Typography>
      </Skeleton>
    </Stack>
  </Stack>
)
